export default __webpack_public_path__ + "static/media/viber-color.aa88c16e.svg";